// ============================================================
// cf-cell-render.js â€” Consistent Cell Renderers & Row Action Configs
// Bundled into wwwroot/js/dist/cf-bundle.js by esbuild.
//
// Dependencies: cf-form-helpers.js (CF.formHelpers.escHtml)
//
// Provides CF.cellRender:
//   .isActive(val)               â€” Active / Inactive badge
//   .isSystem(val)               â€” System badge or muted dash
//   .isDefault(val)              â€” Default star badge or muted dash
//   .isVisible(val)              â€” Visible / Hidden badge
//   .code(val)                   â€” Monospace code span
//   .orderIndex(val)             â€” Muted order number
//   .level(val, prefix)          â€” Level badge (lv-0 / lv-1 / lv-2)
//   .yesNo(val)                  â€” Yes badge or "No" muted text
//   .muted()                     â€” Standard em-dash placeholder
//   .truncate(val, maxLen)       â€” Truncated text with title tooltip
//   .date(val)                   â€” Formatted date "DD MMM YYYY"
//   .approvalStatus(status, e)   â€” Approval status badge w/ icon (Instance/Step/Approver)
//   .slaCountdown(dueAt, hours)  â€” SLA countdown badge w/ color coding
//
// Provides CF.rowActions (standard action config objects):
//   .view / .edit / .addChild / .toggleActive / .toggleVisibility
//   .toggleDefault / .resetPassword / .delete / .divider
// ============================================================

window.CF = window.CF || {};

// ============================================================
// CF.cellRender
// ============================================================
CF.cellRender = (function () {
    'use strict';

    var esc  = function (v) { return CF.formHelpers.escHtml('' + (v == null ? '' : v)); };
    var DASH = '<span class="cf-muted-dash">&mdash;</span>';

    /**
     * Active / Inactive status badge.
     * @param {boolean} val
     */
    function isActive(val) {
        if (val) {
            return '<span class="badge badge-active"><span class="badge-dot"></span> Active</span>';
        }
        return '<span class="badge badge-inactive"><span class="badge-dot"></span> Inactive</span>';
    }

    /**
     * System flag badge or muted dash.
     * @param {boolean} val
     */
    function isSystem(val) {
        if (val) {
            return '<span class="badge badge-active"><span class="badge-dot"></span> System</span>';
        }
        return DASH;
    }

    /**
     * Default flag badge (star) or muted dash.
     * @param {boolean} val
     */
    function isDefault(val) {
        if (val) {
            return '<span class="sp-badge-def"><i class="fa-solid fa-star" style="font-size:9px"></i> Default</span>';
        }
        return DASH;
    }

    /**
     * Visible / Hidden status badge.
     * @param {boolean} val
     */
    function isVisible(val) {
        if (val) {
            return '<span class="badge badge-active"><span class="badge-dot"></span> Visible</span>';
        }
        return '<span class="badge badge-inactive"><span class="badge-dot"></span> Hidden</span>';
    }

    /**
     * Monospace code span.
     * @param {string} val
     */
    function code(val) {
        if (!val && val !== 0) return DASH;
        return '<span class="cell-code">' + esc(val) + '</span>';
    }

    /**
     * Order index in muted style.
     * @param {number} val
     */
    function orderIndex(val) {
        if (val == null) return DASH;
        return '<span class="cf-muted-text">' + val + '</span>';
    }

    /**
     * Hierarchical level badge with lv-N class (supports 0ï¿½2+).
     * @param {number} val   ï¿½ numeric level value
     * @param {string} [prefix] ï¿½ label prefix, defaults to "Level"
     */
    function level(val, prefix) {
        var num = parseInt(val, 10);
        var cls = num <= 0 ? 'lv-0' : num === 1 ? 'lv-1' : 'lv-2';
        var lbl = (prefix || 'Level') + ' ' + num;
        return '<span class="lv-badge ' + cls + '">' + esc(lbl) + '</span>';
    }

    /**
     * Boolean rendered as "Yes" badge or "No" muted text.
     * Useful in view modals (isMenu, isSystem, etc.).
     * @param {boolean} val
     */
    function yesNo(val) {
        if (val) {
            return '<span class="badge badge-active"><span class="badge-dot"></span> Yes</span>';
        }
        return '<span class="cf-muted-text">No</span>';
    }

    /**
     * Standard em-dash placeholder for empty / null values.
     */
    function muted() {
        return DASH;
    }

    /**
     * Truncated text with title tooltip for long values.
     * @param {string} val
     * @param {number} [maxLen=60]
     */
    function truncate(val, maxLen) {
        if (!val) return DASH;
        maxLen = maxLen || 60;
        var text = val.length > maxLen ? val.substring(0, maxLen) + '\u2026' : val;
        return '<span class="cf-detail-value-sm" title="' + esc(val) + '">' + esc(text) + '</span>';
    }

    /**
     * Formatted date in muted style. Returns em-dash if null/empty.
     * Uses locale 'en-GB' for "DD MMM YYYY" format.
     * @param {string|Date} val â€” ISO date string or Date
     */
    function date(val) {
        if (!val) return DASH;
        var d = val instanceof Date ? val : new Date(val);
        if (isNaN(d.getTime())) return DASH;
        var text = d.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
        return '<span class="cf-detail-value-muted">' + esc(text) + '</span>';
    }

    // â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
    // Approval status badge (Instance / Step / Approver)
    // Source of truth: ArunaSalesPro.Shared.Constants.ApprovalStatuses
    // Mapping documented in docs/approval-engine/13-ux-design.md Â§2.1
    // â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
    var APPROVAL_STATUS_MAP = {
        instance: {
            Submitted:  { cls: 'badge-info',     icon: 'fa-paper-plane',     label: 'Submitted' },
            InProgress: { cls: 'badge-info',     icon: 'fa-spinner',         label: 'In Progress' },
            Approved:   { cls: 'badge-active',   icon: 'fa-circle-check',    label: 'Approved' },
            Rejected:   { cls: 'badge-danger',   icon: 'fa-circle-xmark',    label: 'Rejected' },
            Revised:    { cls: 'badge-warning',  icon: 'fa-rotate-left',     label: 'Revised' }
        },
        step: {
            Pending:    { cls: 'badge-inactive', icon: 'fa-hourglass-half',  label: 'Pending' },
            Active:     { cls: 'badge-info',     icon: 'fa-play',            label: 'Active' },
            Approved:   { cls: 'badge-active',   icon: 'fa-check',           label: 'Approved' },
            Rejected:   { cls: 'badge-danger',   icon: 'fa-xmark',           label: 'Rejected' },
            Skipped:    { cls: 'badge-inactive', icon: 'fa-forward',         label: 'Skipped' },
            Returned:   { cls: 'badge-warning',  icon: 'fa-rotate-left',     label: 'Returned' }
        },
        approver: {
            Pending:    { cls: 'badge-inactive', icon: 'fa-circle',          label: 'Pending' },
            Approved:   { cls: 'badge-active',   icon: 'fa-circle-check',    label: 'Approved' },
            Rejected:   { cls: 'badge-danger',   icon: 'fa-circle-xmark',    label: 'Rejected' },
            Revised:    { cls: 'badge-warning',  icon: 'fa-rotate-left',     label: 'Revised' },
            Delegated:  { cls: 'badge-info',     icon: 'fa-share',           label: 'Delegated' },
            Skipped:    { cls: 'badge-inactive', icon: 'fa-forward',         label: 'Skipped' }
        }
    };

    /**
     * Approval status badge with icon. Used for Instance / Step / Approver tables.
     *
     * @param {string} status   â€” status name (e.g. "InProgress", "Approved")
     * @param {string} [entity] â€” "instance" (default) | "step" | "approver"
     */
    function approvalStatus(status, entity) {
        if (!status) return DASH;
        var ent = (entity || 'instance').toLowerCase();
        var map = APPROVAL_STATUS_MAP[ent] || APPROVAL_STATUS_MAP.instance;
        var cfg = map[status];
        if (!cfg) {
            return '<span class="badge badge-inactive"><i class="fa-solid fa-question"></i> ' + esc(status) + '</span>';
        }
        return '<span class="badge ' + cfg.cls + '">' +
            '<i class="fa-solid ' + cfg.icon + '" aria-hidden="true"></i> ' +
            esc(cfg.label) +
            '</span>';
    }

    // â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
    // SLA countdown badge with color coding
    // â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
    function _formatDuration(ms) {
        var totalMin = Math.floor(Math.abs(ms) / 60000);
        var d = Math.floor(totalMin / 1440);
        var h = Math.floor((totalMin % 1440) / 60);
        var m = totalMin % 60;
        if (d >= 7) return d + 'd';
        if (d >= 1) return d + 'd ' + h + 'h';
        if (h >= 1) return h + 'h ' + m + 'm';
        return m + 'm';
    }

    /**
     * SLA countdown badge with color coding:
     *   > 50% remaining â†’ green (badge-active)
     *   10-50%          â†’ yellow (badge-warning)
     *   < 10%           â†’ red (badge-danger)
     *   < 0% (overdue)  â†’ red pulse (badge-danger badge-pulse)
     *   no SLA          â†’ muted dash
     *
     * @param {string|Date|null} dueAt    â€” DueAt timestamp (ISO string or Date)
     * @param {number|null}      slaHours â€” total SLA hours allotted to the step
     */
    function slaCountdown(dueAt, slaHours) {
        if (!dueAt || !slaHours || slaHours <= 0) return DASH;
        var due = dueAt instanceof Date ? dueAt : new Date(dueAt);
        if (isNaN(due.getTime())) return DASH;

        var now = new Date();
        var diff = due.getTime() - now.getTime();              // ms remaining (negative = overdue)
        var total = slaHours * 3600 * 1000;
        var pct = (diff / total) * 100;

        var cls, label, icon;
        if (diff < 0) {
            cls = 'badge-danger badge-pulse';
            icon = 'fa-circle-exclamation';
            label = 'OVERDUE ' + _formatDuration(diff);
        } else if (pct < 10) {
            cls = 'badge-danger';
            icon = 'fa-clock';
            label = _formatDuration(diff) + ' left';
        } else if (pct < 50) {
            cls = 'badge-warning';
            icon = 'fa-clock';
            label = _formatDuration(diff) + ' left';
        } else {
            cls = 'badge-active';
            icon = 'fa-clock';
            label = _formatDuration(diff) + ' left';
        }

        return '<span class="badge ' + cls + '" title="Due: ' + esc(due.toLocaleString('en-GB')) + '">' +
            '<i class="fa-solid ' + icon + '" aria-hidden="true"></i> ' +
            esc(label) +
            '</span>';
    }

    return {
        isActive:       isActive,
        isSystem:       isSystem,
        isDefault:      isDefault,
        isVisible:      isVisible,
        code:           code,
        orderIndex:     orderIndex,
        level:          level,
        yesNo:          yesNo,
        muted:          muted,
        truncate:       truncate,
        date:           date,
        approvalStatus: approvalStatus,
        slaCountdown:   slaCountdown
    };
})();

// ============================================================
// CF.rowActions ï¿½ Standard row action config objects
//
// Usage in page scripts:
//   rowActions: [
//       CF.rowActions.view,
//       CF.rowActions.edit,
//       CF.rowActions.addChild,
//       CF.rowActions.divider,
//       CF.rowActions.delete
//   ]
//
// Action strings used in onRowAction:
//   'view' | 'edit' | 'add-child' | 'toggle-active' |
//   'toggle-visibility' | 'toggle-default' | 'reset-password' | 'delete'
// ============================================================
CF.rowActions = (function () {
    'use strict';

    // Each row action carries a `withPermission(code)` method that returns
    // a shallow copy with the permission attached. Keeps page scripts terse:
    //   rowActions: [
    //       CF.rowActions.view.withPermission('app.users.view'),
    //       CF.rowActions.edit.withPermission('app.users.edit'),
    //       CF.rowActions.delete.withPermission('app.users.delete'),
    //   ]
    // CF.dataTable filters out rowActions whose `permission` the user lacks.
    function _withPermission(perm) {
        var copy = {};
        for (var k in this) {
            if (this.hasOwnProperty(k) && k !== 'withPermission') copy[k] = this[k];
        }
        if (perm) copy.permission = perm;
        copy.withPermission = _withPermission;
        return copy;
    }

    function make(label, icon, action, danger) {
        var o = { label: label, icon: icon, action: action };
        if (danger) o.danger = true;
        o.withPermission = _withPermission;
        return o;
    }

    return {
        view:             make('View',              'fa-solid fa-eye',         'view'),
        edit:             make('Edit',              'fa-solid fa-pen',         'edit'),
        addChild:         make('Add Child',         'fa-solid fa-sitemap',     'add-child'),
        toggleActive:     make('Toggle Active',     'fa-solid fa-toggle-on',   'toggle-active'),
        toggleVisibility: make('Toggle Visibility', 'fa-solid fa-eye-slash',   'toggle-visibility'),
        toggleDefault:    make('Toggle Default',    'fa-solid fa-star',        'toggle-default'),
        resetPassword:    make('Reset Password',    'fa-solid fa-key',         'reset-password'),
        delete:           make('Delete',            'fa-solid fa-trash',       'delete', true),
        divider:          { divider: true }
    };
})();
